import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import AntRadio from 'antd/es/radio';
import './Radio.scss';

/**
 * Radio.
 */
const propTypes = {

}
const Radio = p => {

  const className = classnames(
    'Radio',
    p.className
  )

  return(
    <AntRadio className="Radio" { ...p }/>
  )

};
Radio.propTypes = propTypes;
Radio.Group = AntRadio.Group;
Radio.Button = AntRadio.Button;

export default Radio;
